import { defineComponent as _defineComponent } from 'vue'
import FeesListing from 'ah-trades/src/components/fees/FeesListing.vue';
import { LoadingIcon } from 'ah-common-lib/src/icons/components';
import AddMoneyModal from 'ah-wallets/src/components/AddMoneyModal.vue';
import FeeSettleModal from './FeeSettleModal.vue';
import CreateTradeModal from 'ah-trades/src/components/modals/CreateTradeModal.vue';
import { VButton } from 'ah-common-lib/src/common/components';
import { AuthorityType, PaginatedParams } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, ref } from 'vue';
import { useTradeState } from '../..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeesInfoBlock',
  props: {
    referenceWalletId: null
  },
  emits: ["fees-changed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'fees-changed', value: void): void;
}), expose: any, slots: any, attrs: any }) {





const onBehalfOfClient = useOnBehalfOf();

const feesListing = ref<InstanceType<typeof FeesListing> | null>(null);

const feesSortAndPageParams = ref<Partial<PaginatedParams>>({ sort: 'createdAt' });

const tradeState = useTradeState();

const requestManager = useRequestManager({
  exposeToParent: ['loadFeesInfo'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadFeesInfo') {
      created();
    }
  },
});

const canSeeFundingDetails = computed(() =>
  tradeState.store.useAuthStore().hasAuthorities(AuthorityType.VIEW_FUNDING_DETAILS)
);

const isPartnerUser = computed(() => !onBehalfOfClient.value?.id && !tradeState.store.useAuthStore().isClientUser);

const owner = computed(() => {
  return {
    isPartner: isPartnerUser.value && !onBehalfOfClient.value,
    id: onBehalfOfClient.value?.id || tradeState.store.useAuthStore().loggedInIdentity?.client?.id,
  };
});

const feesInfo = computed(() => {
  return isPartnerUser.value
    ? tradeState.store.useWalletsStore().getPartnerFeesInfo()
    : tradeState.store.useWalletsStore().getClientFeesInfo(feesClientId.value!);
});

const debtCurrency = computed(() => feesInfo.value?.debtCurrency || 'GBP');

const wallet = computed(() => tradeState.store.useWalletsStore().getWallet(debtCurrency.value, owner.value));

const hasEnoughBalance = computed(() => (wallet.value?.availableBalance || 0) >= (feesInfo.value?.debtCumulative || 0));

const withOutstandingFees = computed(() => feesInfo.value && feesInfo.value.debtCumulative > 0);

const openTradeAllowed = computed(
  () => onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.OPEN_TRADE)
);

const requestPricesAllowed = computed(
  () => onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.REQUEST_PRICES)
);

const debtCumulative = computed(() => feesInfo.value?.debtCumulative || 'GBP');

const feesClientId = computed(
  () => onBehalfOfClient.value?.id ?? tradeState.store.useAuthStore().loggedInIdentity!.client?.id
);

const canSettleFees = computed(
  () => onBehalfOfClient.value ?? tradeState.store.useAuthStore().hasAuthorities(AuthorityType.MANAGE_WALLETS)
);

function loadFees() {
  if (tradeState.store.useAuthStore().isLoggedIn) {
    return requestManager.manager.newPromise(
      'loadFeesInfo',
      isPartnerUser.value
        ? tradeState.store.useWalletsStore().loadPartnerFeesInfo({ force: true })
        : tradeState.store.useWalletsStore().loadClientFeesInfo({ force: true, clientId: feesClientId.value! })
    );
  }
}

function onFeesChanged() {
  loadFees()?.then(() => {
    emit('fees-changed');
    feesListing.value?.loadData();
  });
}
function created() {
  tradeState.store.useWalletsStore().loadCurrencyWallet({ currency: debtCurrency.value, owner: owner.value });
  loadFees();
}

created();

return { __sfc: true,emit, onBehalfOfClient, feesListing, feesSortAndPageParams, tradeState, requestManager, canSeeFundingDetails, isPartnerUser, owner, feesInfo, debtCurrency, wallet, hasEnoughBalance, withOutstandingFees, openTradeAllowed, requestPricesAllowed, debtCumulative, feesClientId, canSettleFees, loadFees, onFeesChanged, created, FeesListing, LoadingIcon, AddMoneyModal, FeeSettleModal, CreateTradeModal, VButton, formatCurrencyValue }
}

})